module.exports = __webpack_public_path__ + "static/media/VIDASSISTANCE-MAS.a00e812f.jpg";